export default function OddsUtilsDescription() {
    return (
        <>
            <p>
                The <b>odds helpers</b> are a set of utilities that will process
                the raw odds in different formats (e.g. Raw: 1610, Decimal 1.61,
                American -165, Fractional 160/1)
            </p>
            <p>
                Please click on one of the functions below to get more
                information about it
            </p>
        </>
    );
}
